import { useEffect, useRef, useState } from "react";

import { css } from "@emotion/react";
import Grid from "@mui/material/Grid";

import { colors } from "@dotnet/telematics-design-system";

import ActionBar from "components/Actions/ActionBar";
import MainContainer from "components/MainContainer";
import { DASHBOARD } from "shared/constants/navigation";

import LeftSide from "./LeftSide";
import RightSide from "./RightSide";

const Dashboard = () => {
    const { gray50 } = colors;

    const leftSideRef = useRef<HTMLDivElement>(null);
    const rightSideRef = useRef<HTMLDivElement>(null);

    const [rightSideHeight, setRightSideHeight] = useState("unset");

    // Set the initial height of the right side based on the left side's height
    useEffect(() => {
        if (!leftSideRef.current) return;

        const observer = new ResizeObserver(([entry]) => {
            const newHeight = entry.contentRect.height;
            setRightSideHeight(`${newHeight}px`);
        });

        observer.observe(leftSideRef.current);

        return () => observer.disconnect();
    }, []);

    return (
        <MainContainer>
            <ActionBar name={DASHBOARD} />

            <section className="remaining-height">
                <div
                    css={css({
                        flex: 1,
                        background: gray50,
                        padding: "0 24px 24px"
                    })}
                >
                    <Grid
                        container
                        spacing={2}
                        css={css({
                            "& > div": {
                                "& > div + div": {
                                    marginTop: "16px"
                                }
                            }
                        })}
                    >
                        <Grid size={{ xs0: 12, mdLg: 6, lg: 8 }}>
                            <LeftSide ref={leftSideRef} />
                        </Grid>

                        <Grid
                            ref={rightSideRef}
                            size={{ xs0: 12, mdLg: 6, lg: 4 }}
                            css={css({
                                display: "flex",
                                flexDirection: "column",
                                height: rightSideHeight,

                                "@media (max-width: 1099px)": {
                                    height: "unset"
                                }
                            })}
                        >
                            <RightSide />
                        </Grid>
                    </Grid>
                </div>
            </section>
        </MainContainer>
    );
};

export default Dashboard;
